import { dom } from '../utils/dom';
import pubSub from '../utils/pubSub';
import { TweenMax, Expo } from 'gsap';

const PAD = 30;

class Slider {
  constructor(el) {
    this.init(el);
  }

  init(el) {
    this.el = el;
    this.varEl = el.parentNode.querySelector('.var-val');
    this.min = parseFloat(el.dataset.min);
    this.max = parseFloat(el.dataset.max);
    this.range = this.max - this.min;
    if (el.dataset.step != null) {
      this.step = parseFloat(el.dataset.step);
    }
    this.type = '<small>hrs</small>'; // el.parentNode.classList.contains('percent') ? '%' : '$';
    this.rect = el.getBoundingClientRect();
    this.varName = el.parentNode.dataset.el;
    this.col = el.dataset.col;

    this.onDown = this.onDown.bind(this);
    this.onMove = this.onMove.bind(this);
    this.onUp = this.onUp.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onVarChanged = this.onVarChanged.bind(this);

    this.onResize();
    this.initEvents();
    this.createElements();
    this.render();
  }

  initEvents() {
    this.el.addEventListener(dom.downOrTouchStart(), this.onDown);
    document.addEventListener(dom.moveOrTouchMove(), this.onMove);
    document.addEventListener(dom.upOrTouchEnd(), this.onUp);
    window.addEventListener('resize', this.onResize);
    pubSub.on('var:set', this.onVarChanged);
  }

  onVarChanged(e) {
    if (e.name === this.varName) {
      const percent = (e.val - this.min) / this.range;
      this.clampedPercent = percent * 100;
      this.x = (this.rectWidth() - this.dotSize) * percent;
      this.update();
      this.render();
    }
  }

  rectWidth() {
    return this.rect.width + this.rect.width * 0.01;
  }

  createElements() {
    this.dot = document.createElement('div');
    this.leftLine = document.createElement('div');
    this.rightLine = document.createElement('div');
    this.dotSize = this.rect.height - 20;
    this.halfDotSize = this.dotSize / 2;

    dom.style(this.dot, {
      position: 'absolute',
      left: 0,
      top: 10,
      width: this.dotSize,
      height: this.dotSize,
      background: this.col,
      borderRadius: '50%'
    });
    this.dot.setAttribute('class', 'dot');

    dom.style(this.leftLine, {
      position: 'absolute',

      left: 0,
      top: '50%'
      // borderBottom: `1px solid ${this.col}`
    });

    dom.style(this.rightLine, {
      position: 'absolute',

      right: 0,
      top: '50%'
      // borderBottom: '1px solid #D8D8D8'
    });

    this.rightLine.classList.add('slider-line', 'slider-line-right');
    this.leftLine.classList.add('slider-line', 'slider-line-left');

    this.el.appendChild(this.leftLine);
    this.el.appendChild(this.rightLine);
    this.el.appendChild(this.dot);
    this.elementsCreated = true;
  }

  onResize(e) {
    this.pad = (dom.innerWidth() - this.el.clientWidth) / 2;
    this.rect = this.el.getBoundingClientRect();
    if (this.elementsCreated) {
      this.update();
      this.render();
    }
  }

  onDown(e) {
    this.down = true;
    if (document.activeElement) {
      document.activeElement.blur();
    }
    if (!this.firstTimeAround) {
      dom.els.hoursPerWeekCheck.style.opacity = 1;
      this.firstTimeAround = true;
    }
    this.onMove(e);
  }

  onMove(e) {
    const loc = dom.touchify(e);

    if (this.down && loc.pageX != null) {
      e.preventDefault();
      this.calcPercent(loc.pageX);
      this.render();
      this.update();
    }
  }

  onUp(e) {
    this.down = false;
  }

  calcPercent(pageX) {
    this.x = pageX - this.pad - this.halfDotSize;
    this.percent = this.x / (this.rectWidth() - this.dotSize);
    this.clampedPercent = Math.round(
      Math.min(Math.max(0, this.percent * 100), 100)
    );
  }

  render() {
    const right = this.rectWidth() - this.dotSize;
    const x = Math.min(right, Math.max(0, this.x));
    dom.style(this.leftLine, {
      width: x
    });
    dom.style(this.rightLine, {
      left: x
    });

    dom.style(this.dot, {
      left: x
    });
  }

  clamp(min, max, num) {
    return Math.max(Math.min(num, max), min);
  }

  update() {
    const percent = this.clampedPercent / 100;
    this.actualValue = Math.round(percent * this.range + this.min);

    // clamp value to the step
    if (this.step != null) {
      let value = (this.range + this.step) * percent + this.min;
      let clamped =
        value -
        Math.abs(value % this.step) +
        Math.abs(this.step / 2) +
        this.step / 2;
      clamped = this.clamp(this.min, this.max + this.step, clamped) - this.step;
      this.actualValue = clamped;
    }

    // update text
    if (this.type === '%') {
      this.varEl.innerText = this.actualValue + '%';
    } else if (this.type === '$') {
      this.varEl.innerText = '$' + this.actualValue;
    } else {
      this.varEl.innerHTML =
        this.actualValue + '<small style="font-size:30px">hrs</small>';
    }

    // @TODO fix
    window.$hours = this.actualValue;

    pubSub.trigger('var:changed', {
      name: this.varName,
      val: this.actualValue
    });
  }
}

export default Slider;
